
const checkLesiones = (data,soloTitulares) => {
    if(data === undefined || !data) return []
    if(typeof data != "object")data = data != null ? JSON.parse(data) : null
    
    let titulares = Object.assign({}, data.teams[0].players)
    let injuredPlayers = [];
    if(soloTitulares) titulares = data.teams[0].players.slice(0,7)
    
    for(let i = 0; i < titulares.length; i++) {
        if(titulares[i].injury > 0) injuredPlayers.push({...titulares[i],index:i})
    }

    return injuredPlayers;
}
export default checkLesiones